import { CloseIcon } from "components/common/Icons/CloseIcon";
import { Modal } from "components/common/Modal/Modal";
import { LI } from "../LI/LI";
import { SelectProps } from "../Select";

interface MobileOptionsProps<T> {
    isFocused: boolean;
    options: SelectProps<T>["options"];
    selected: SelectProps<T>["options"][number] | null;
    getOptionLabel: SelectProps<T>["getOptionLabel"];
    getOptionValue: SelectProps<T>["getOptionValue"];
    handleOptionClick: (option: T) => void;
    handleClose: () => void;
    testKey: string;
    label?: SelectProps<T>["label"];
    labelClassNames?: SelectProps<T>["labelClassNames"];
}

export const MobileOptions = <T,>({
    isFocused,
    options,
    selected,
    getOptionLabel,
    getOptionValue,
    handleOptionClick,
    handleClose,
    label,
    labelClassNames,
    testKey,
}: MobileOptionsProps<T>) => {
    const _handleOptionClick = (option: T) => {
        handleOptionClick(option);
        handleClose();
    };

    return (
        <Modal isOpen={isFocused} close={handleClose} backgroundScroll={false} isOverBottomModal={true}>
            <div className="flex items-center justify-center h-full" onClick={handleClose}>
                <div
                    className="py-4 rounded-md flex flex-col items-center justify-center max-h-full"
                    onClick={(e) => e.stopPropagation()}
                >
                    <ul className="overflow-y-auto flex flex-col bg-white dark:bg-darkSurface-200 rounded-lg border-slate-200 dark:border-darkSurface-100 border scroll text-black dark:text-white min-w-[300px]">
                        <div className="sticky top-0 p-4 flex justify-between items-center bg-white dark:bg-darkSurface-200 w-full border-b border-b-irGray-400 text-black dark:text-white">
                            <div>
                                {label && (
                                    <div
                                        className={`${labelClassNames} text-xl font-semibold`}
                                        data-testid={`${testKey}-modal-label`}
                                    >
                                        {label}
                                    </div>
                                )}
                            </div>
                            <div
                                className="w-6 h-6 bg-irGray-300 dark:bg-darkSurface-300 rounded-full flex items-center justify-center"
                                onClick={handleClose}
                                data-testid={`${testKey}-close-icon`}
                            >
                                <CloseIcon />
                            </div>
                        </div>

                        {options.map((option, index) => (
                            <LI
                                option={option}
                                key={index}
                                getOptionLabel={getOptionLabel}
                                getOptionValue={getOptionValue}
                                handleClick={_handleOptionClick}
                                isMobile={true}
                                isSelected={selected ? getOptionValue(option) === getOptionValue(selected) : false}
                                testKey={testKey}
                            />
                        ))}
                    </ul>
                </div>
            </div>
        </Modal>
    );
};
